/* ============================================================
   Aqua Gold — Homepage FX (v2 — no cursor)
   2026-05-21
   - Magnetic hero buttons
   - 3D tilt on material cards
   - Reveal-on-scroll
   - Hero word-by-word reveal
   ============================================================ */
(function () {
  if (typeof window === 'undefined') return;
  if (!document.body.classList.contains('template-index')) return;

  const isCoarse = window.matchMedia('(pointer: coarse)').matches;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* === Magnetic hero buttons === */
  if (!isCoarse && !reduced) {
    document.querySelectorAll('.ag-hero-v2__btn').forEach((btn) => {
      btn.addEventListener('mousemove', (e) => {
        const r = btn.getBoundingClientRect();
        const x = e.clientX - r.left - r.width / 2;
        const y = e.clientY - r.top - r.height / 2;
        btn.style.transform = `translate(${x * 0.18}px, ${y * 0.25}px)`;
      });
      btn.addEventListener('mouseleave', () => { btn.style.transform = ''; });
    });
  }

  /* === Tilt on material cards === */
  if (!isCoarse && !reduced) {
    document.querySelectorAll('[id*="aqua_gold_standard"] .service-item').forEach((card) => {
      card.style.transformStyle = 'preserve-3d';
      card.style.transition = 'transform .45s ease, background .35s ease, border-color .35s ease';
      card.addEventListener('mousemove', (e) => {
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = `perspective(900px) rotateY(${x * 6}deg) rotateX(${-y * 6}deg) translateZ(8px)`;
      });
      card.addEventListener('mouseleave', () => { card.style.transform = ''; });
    });
  }

  /* === Scroll-reveal === */
  if (!reduced && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('ag-fx-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -10% 0px' });

    document.querySelectorAll('.ag-fx-reveal').forEach((el) => io.observe(el));
  } else {
    document.querySelectorAll('.ag-fx-reveal').forEach((el) => el.classList.add('ag-fx-in'));
  }

  /* === Hero word reveal (v2 — legacy) === */
  const titleV2 = document.querySelector('.ag-hero-v2__title');
  if (titleV2) {
    setTimeout(() => titleV2.classList.add('ag-revealed'), 80);
  }

  /* === v10 HERO — reveal + mouse parallax + scroll parallax === */
  const hero = document.querySelector('.ag-hero');
  const heroBg = document.querySelector('.ag-hero__bg');
  if (hero) {
    setTimeout(() => hero.classList.add('ag-hero--revealed'), 60);

    if (heroBg && !reduced) {
      let mouseX = 0, mouseY = 0;
      let currentX = 0, currentY = 0;
      let scrollOffset = 0;
      let ticking = false;

      const applyTransform = () => {
        // Lerp toward target for smoothness
        currentX += (mouseX - currentX) * 0.06;
        currentY += (mouseY - currentY) * 0.06;
        // Hero now uses object-fit: contain, so no scale needed — any scale
        // here would push image content past the visible area or shift the
        // composition. Pure translate gives subtle editorial movement.
        heroBg.style.transform =
          `translate3d(${currentX}px, ${currentY}px, 0)`;
        ticking = false;
      };

      if (!isCoarse) {
        hero.addEventListener('mousemove', (e) => {
          const rect = hero.getBoundingClientRect();
          const nx = (e.clientX - rect.width / 2) / rect.width;   // -0.5 .. 0.5
          const ny = (e.clientY - rect.height / 2) / rect.height;
          mouseX = nx * -14;
          mouseY = ny * -11;
          if (!ticking) {
            requestAnimationFrame(applyTransform);
            ticking = true;
          }
        });
        hero.addEventListener('mouseleave', () => {
          mouseX = 0; mouseY = 0;
          if (!ticking) { requestAnimationFrame(applyTransform); ticking = true; }
        });
      }

      // Scroll parallax removed entirely. Original implementation translated
      // the hero bg up to ~414px on scroll which required a 16% wrapper
      // overscale to avoid exposing edges — that overscale was the main
      // source of the "everything looks too zoomed in" complaint. Mouse
      // parallax above is enough for the editorial feel.
    }
  }
})();
